
import { Vue } from "vue-class-component";

export default class Home extends Vue {
  public outdoorsPpm = 0;
  public indoorsPeakPpm = 0;
  public declined63Time = 0;

  excessPpm(): number {
    return this.indoorsPeakPpm - this.outdoorsPpm;
  }

  declined63Ppm(): number {
    const declineTarget = (100-63)/100;
    return this.outdoorsPpm + declineTarget * this.excessPpm();
  }

  ventilationRate(): number {
    const rate = 1 / this.declined63Time
    return Math.round( rate * 1000) / 1000;
  }
}
